import { atempl } from '@api/v0/fetch/.endpoints';
import AtnlSelect from '@components/atnl-select/script';
import FilterHelpers from '@resources/filter-helpers/FilterHelpers';
import { SwiperSetup } from '@resources/swiper-setup/SwiperSetup';

export class ExploreRequest {
	constructor() {
		this.id = 'explore';
		this.formId = '#explore-filter'
		this.form = document.querySelector(this.formId);
		this.tagsArea = document.querySelector('.explore__indication__chips');
		this.searchTermArea = document.querySelector('.explore [data-search-term]')
		this.searchInput = document.querySelector('.explore [name="search"]');
		this.isInitialized = false;

		this.memory = localStorage.getItem('moth_explore');
		this.memory = this.memory && JSON.parse(this.memory);


		if( this.memory?.expire && this.memory.expire < Date.now() ){
			this.memory = false;
			localStorage.removeItem('moth_explore');
		}

		this.init();

	}

	init() {
		this.isInitialized = true;
		this.eventListeners();
		this.setPayload();
		this.setDataProcessor();
		this.createFilter();

		window.addEventListener('click', (e) => {
			let target = e.target.closest('[data-search-term-clear]');

			if (target && this.searchInput) {
				this.searchInput.value = ''
				this.searchTermArea && (this.searchTermArea.innerText = '')
				this.searchInput.dispatchEvent(new Event('input', { bubbles: true }));
			}
		})

	}

	formMemoryRestore(){
		if( ! this.memory ) return {};

		let tax_filters = this.memory.args?.tax_filters;
		let search = this.memory.args?.search;
		let searchField = document.querySelector(`.explore [name="search"]`)
		let answer = {}

		if( search ){
			searchField.value = search
			answer.search = search;
		}

		this.setFilterIndicators(tax_filters,search)

		if( tax_filters ){
			answer.tax_filters = tax_filters;
			Object.keys(tax_filters).forEach(key => {
				key !== 'relation' && tax_filters[key].terms.forEach(value => {
					let option = document.querySelector(`.explore [data-for="${key}"] [value=${value}]`);
					AtnlSelect.optionChecker(option, true, false);
				});
			})
		}
		this.memoryRestored = true;
		return answer;
	}

	getFormTaxonomiesValues(formData) {
		const taxonomies = ['category', 'post_tag', 'media_type'];
		const answer = {};

		taxonomies.forEach(tax => {
			if (formData[tax] && formData[tax].length) {
				answer[tax] = {
					relation: 'OR',
					property: 'slug',
					terms: formData[tax]
				}
			}
		});
		return answer;
	}


	setPayload() {

		const paged = this.memory && this.memory.args.paged ? this.memory.args.paged : 1;

		atempl.models.setPayload(this.id, {
			'model': 'Search',
			'cache': false,
			'fields': ['id', 'title', 'permalink', 'byline', 'strapline', 'excerpt', 'thumbnail', 'link'],
			'args': {
				'lang': atnlbs_default.lang,
				'posts_per_page': 12,
				'paged': paged,
				...this.formMemoryRestore(),
			}
		}, {
			'X-WP-Nonce': atnlbs_default.nonce
		});
	}

	setDataProcessor() {
		!atempl.templateProcessor.funcs.hasOwnProperty('makelinkattr') && atempl.templateProcessor.setFunc('makelinkattr', (arr) => {
			return arr && Object.keys(arr).length ? `href="${arr.url}" target="${arr.target}"` : ''
		});
		!atempl.templateProcessor.funcs.hasOwnProperty('linkTitle') && atempl.templateProcessor.setFunc('linkTitle', (arr) => {
			return arr?.title ? arr.title : ''
		});
	}

	setUrlHandler() {

		this.urlHandler = {
			'setter': (payloadArgs) => {
				const taxFilters = {
					category: payloadArgs.tax_filters?.category,
				};

				const nonTaxFilters = {
					f_year: payloadArgs.year,
				};

				return FilterHelpers.buildFilterUrl(window.location.href, taxFilters, nonTaxFilters);
			},
			'getter': (urlParams) => {
				let get = {
					tax_filters: {
						category: FilterHelpers.getTaxTerm(urlParams, 'category'),
					},
					year: urlParams.f_year
				};

				Object.keys(get.tax_filters).forEach(k => !get.tax_filters[k] && delete get.tax_filters[k]);
				if (Object.keys(get.tax_filters).length === 0) delete get.tax_filters;
				if (!get.year) delete get.year;
				return get;
			},
			'interface': (filterForm, urlParams, payload) => {
				FilterHelpers.applyFiltersToAtnlSelects(
					filterForm,
					urlParams,
					['category'],
					['f_year']
				);
			}
		};
	}

	createFilter() {
		const formId = this.formId;
		atempl.createFilter(this.id, formId, this.urlHandler);

		const setFilter = (args, data) => {
			args.paged = 1;
			args.search = data.search.length ? data.search : null;
			args.tax_filters = { ...this.getFormTaxonomiesValues(data), relation: 'AND' }

			if (Object.keys(args.tax_filters).length === 1) {
				delete args.tax_filters;
			}
			return args;
		}

		atempl.setFilterStep(this.id, 'input', setFilter, 1000);

		atempl.setFilterStep(this.id, 'change', setFilter, 1000);
	}

	setFilterIndicators(filters,search) {
		const terms = [];

		if (filters) {
			Object.keys(filters).forEach(tax => {
				if (tax !== 'relation') {
					filters[tax].terms.forEach(term => {
						let element = document.querySelector(`.explore [data-for="${tax}"] [value="${term}"]`);
						terms.push({
							label: element.nextElementSibling.textContent.trim(),
							option: element.parentElement,
						})
					})
				}
			})
		}

		this.tagsArea.innerHTML = '';
		terms.length && terms.forEach(term => {
			if (!term.label) return;
			let chip = document.createElement('span');
			let button = document.createElement('button');
			button.setAttribute('type', 'button');
			button.addEventListener('click', (e) => {
				e.target.remove();
				AtnlSelect.optionChecker(term.option, false, true);
			})
			chip.innerText = term.label
			chip.insertAdjacentElement('beforeEnd', button)
			this.tagsArea.insertAdjacentElement('afterbegin', chip);
		})

		if (this.searchInput && this.searchTermArea)
			this.searchTermArea.innerText = search ? search : '';
	}

	eventListeners() {
		// Check if has filter
		window.addEventListener('atempl:hasFilter', (e) => {
			if (e.detail.templ.id !== 'explore') return;
			const state = (e.detail.payload.body.args.tax_filters && Object.keys(e.detail.payload.body.args.tax_filters).length) || e.detail.payload.body.args.search
			let slider = document.querySelector('.explore__slider [data-swiper-id]');
			let swiper = slider && SwiperSetup.swiperList[slider.dataset.swiperId]
			swiper && (state ? swiper && swiper.autoplay.pause() : swiper.autoplay.run())
			e.detail.result = state ? true : false
		})

		// Cancel fetch case it does not have filters.
		window.addEventListener('atempl:beforeFetch', (e) => {
			if (e.detail.templ.id !== 'explore' ) return;
			const hasFilter = (e.detail.payload.body.args.tax_filters && Object.keys(e.detail.payload.body.args.tax_filters).length) || e.detail.payload.body.args.search;
			if (!hasFilter) {
				e.preventDefault();
				localStorage.removeItem('moth_explore');
			}
		})

		window.addEventListener('atempl:afterFetch', (e) => {
			if (e.detail.templ.id !== 'explore') return;
			const hasFilter = (e.detail.payload.body.args.tax_filters && Object.keys(e.detail.payload.body.args.tax_filters).length) || e.detail.payload.body.args.search;

			if( hasFilter ){

				let lastKey = atempl.models.requests['explore'].length - 1;
				let finalRecord = [];
				let stop = false;

				while( ! stop && lastKey >= 0 && atempl.models.requests['explore'][lastKey].pagination.curr_page >= 1 ){
					finalRecord.push( atempl.models.requests['explore'][lastKey] )
					stop = atempl.models.requests['explore'][lastKey].pagination.curr_page === 1
					--lastKey;
				}

				localStorage.setItem('moth_explore', JSON.stringify({
					expire: Date.now() + 15 * 60 * 1000,
					requests: finalRecord.reverse(),
					args: e.detail.payload.body.args,
				}));
			}
		})

		// Clear Form on reset.
		window.addEventListener('atempl:reset', (e) => {
			if (e.detail.templ.id !== 'explore') return;
			const form = document.querySelector(this.formId);
			if (!form) return;
			let selClears = form.querySelectorAll('.atnlsel');
			this.searchInput = form.querySelector('[name="search"]');
			this.searchInput && (this.searchInput.value = '');
			localStorage.removeItem('moth_explore')
			selClears && selClears.forEach(el => AtnlSelect.clear(el, false));
		})

		// Insert information into form indicators.
		window.addEventListener('atempl:beforeFilter', (e) => {
			if (e.detail.templ.id !== 'explore') return;
			const filters = e.detail.filterArgs?.tax_filters;
			const search = e.detail.filterArgs.search;
			this.setFilterIndicators(filters,search)
		})

		// Replace fetch by saved state.
		window.addEventListener('atempl:fetch', (e) => {
			if (e.detail.templ.id !== 'explore' || !this.memory?.requests?.length || !this.memoryRestored) return;

			const lastPage = this.memory.requests[this.memory.requests.length - 1];
			let key = 0;
			let posts = [];
			while (  this.memory.requests[key] ) {
				posts = posts.concat( this.memory.requests[key].posts );
				++key;
			}
			lastPage.posts = posts;
			e.detail.response = lastPage;
			this.memoryRestored = false;
			e.detail.payload.initArgs.tax_filters && delete e.detail.payload.initArgs.tax_filters
			e.detail.payload.initArgs.search && delete e.detail.payload.initArgs.search
			e.detail.payload.initArgs.paged = 1
			return true;
		})
	}

}

new ExploreRequest();
